<template>
  <div class="mt">
    <template>
      <div
        v-if="formErrors.non_field_errors !== undefined"
        class="alert alert-danger"
        role="alert"
      >
        {{ formErrors.non_field_errors[0] }}
      </div>

      <form @submit.prevent="submitReCaptcha">
        <div class="form-group">
          <label for="first_name">First name</label>
          <input
            id="first_name"
            v-model="formFields.first_name"
            type="text"
            required
          >
          <div
            v-if="formErrors.first_name !== undefined"
            class="invalid-feedback"
          >
            {{ formErrors.first_name[0] }}
          </div>
        </div>

        <div class="form-group">
          <label for="last_name">Last name</label>
          <input
            id="last_name"
            v-model="formFields.last_name"
            type="text"
            required
          >
          <div
            v-if="formErrors.last_name !== undefined"
            class="invalid-feedback"
          >
            {{ formErrors.last_name[0] }}
          </div>
        </div>

        <div class="form-group">
          <label for="email-register">Email address</label>
          <input
            id="email-register"
            v-model="formFields.email"
            type="email"
            required
          >
          <div
            v-if="formErrors.email !== undefined"
            class="invalid-feedback"
          >
            {{ formErrors.email[0] }}
          </div>
        </div>

        <div class="form-group">
          <label for="password1">Password</label>
          <input
            id="password1"
            v-model="formFields.password1"
            type="password"
            required
          >
          <div
            v-if="formErrors.password1 !== undefined"
            class="invalid-feedback"
          >
            {{ formErrors.password1[0] }}
          </div>
        </div>

        <div class="form-group">
          <label for="password2">Confirm password</label>
          <input
            id="password2"
            v-model="formFields.password2"
            type="password"
            required
          >
          <div
            v-if="formErrors.password2 !== undefined"
            class="invalid-feedback"
          >
            {{ formErrors.password2[0] }}
          </div>
        </div>

        <div class="form-group">
          <input
            id="age_requirement"
            v-model="formFields.age_requirement"
            type="checkbox"
          >
          <label for="age_requirement">I am at least 18 years old</label>
          <div
            v-if="formErrors.age_requirement !== undefined"
            class="invalid-feedback"
          >
            {{ formErrors.age_requirement[0] }}
          </div>
        </div>

        <div class="form-group">
          <vue-recaptcha
            ref="recaptcha"
            size="invisible"
            :sitekey="recaptcha_site_key"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
          />
        </div>

        <button
          type="submit"
          class="btn btn-primary"
          :disabled="formSubmitting"
        >
          <template v-if="formSubmitting">
            Registering
            <spinner />
          </template>
          <template v-else>
            Register
          </template>
        </button>

        <p
          v-if="!landingPage"
          class="small"
        >
          Already a member?
          <router-link :to="{ name: 'login' }">
            Log in
          </router-link>
        </p>
      </form>
    </template>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'RegistrationForm',
  components: {
    VueRecaptcha,
  },
  props: {
    landingPage: { type: Boolean, default: false },
  },
  data() {
    return {
      formSubmitting: false,
      formErrors: {},
      formFields: {
        first_name: '',
        last_name: '',
        email: '',
        password1: '',
        password2: '',
        age_requirement: false,
      },
      recaptcha_site_key: process.env.VUE_APP_RE_CAPTCHA_SITE_KEY,
    };
  },
  mounted() {
    const recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit');
    document.head.appendChild(recaptchaScript);
  },
  methods: {
    onCaptchaVerified(recaptchaToken) {
      this.$refs.recaptcha.reset();

      this.submitForm(recaptchaToken);
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    submitReCaptcha() {
      this.formErrors = {};
      this.formSubmitting = true;

      this.$refs.recaptcha.execute();
    },
    async submitForm(recaptchaToken) {
      this.formErrors = {};
      this.formSubmitting = true;

      const postData = {
        first_name: this.formFields.first_name,
        last_name: this.formFields.last_name,
        email: this.formFields.email,
        password1: this.formFields.password1,
        password2: this.formFields.password2,
        recaptcha_token: recaptchaToken,
        age_requirement: this.formFields.age_requirement,
      };

      const responseData = await this.api({
        url: 'users/',
        method: 'POST',
        json: postData,
      });

      this.formSubmitting = false;

      if (responseData.status === 201) {
        // add when they have email verification again
        // this.$router.push({ name: 'flatpage', params: { slug: 'new-member' } });
        this.$router.push({ name: 'login', query: { newSignup: true } });
      } else if (responseData.status === 400) {
        this.formErrors = responseData.body;
      } else {
        this.formErrors = {
          non_field_errors: [
            'Unable to communicate with the server. Please check your '
            + 'connection and try again.',
          ],
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  form, .alert {
    width: 265px;
  }
  form input[type=checkbox] {
    margin-right: 10px;
  }
</style>
